var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 40.723L45.5336 51.6309L72.1655 22L8 40.723Z",
    fill: "#FFFDFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5458 52.3383C45.4909 52.3383 45.4361 52.3313 45.383 52.3153L7.16445 41.199C6.91487 41.1264 6.74316 40.8981 6.74316 40.6379C6.74316 40.3777 6.91487 40.1493 7.16445 40.075L72.5082 21.0233C72.7578 20.9507 73.0286 21.0516 73.1667 21.2746C73.3065 21.4959 73.2817 21.7826 73.1065 21.9774L45.9813 52.1454C45.868 52.2711 45.7087 52.3401 45.5458 52.3401V52.3383ZM9.42135 40.6361L45.3564 51.0869L70.8602 22.7208L9.42135 40.6344V40.6361Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3695 58.5705L21.0361 44.622L63.2693 26.8164L27.7537 46.5762L35.7422 48.9003L26.3695 58.5705Z",
    fill: "#F5CC82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37 59.1562C26.3311 59.1562 26.2921 59.1527 26.2514 59.1438C26.0549 59.1031 25.8939 58.9668 25.8231 58.7792L20.4897 44.8307C20.3764 44.5351 20.518 44.2041 20.8083 44.0819L63.0432 26.2764C63.33 26.156 63.661 26.2799 63.7973 26.5596C63.9336 26.8393 63.8274 27.1756 63.5548 27.3278L29.2642 46.4061L35.9056 48.3373C36.1021 48.3939 36.2561 48.5515 36.3074 48.7497C36.3605 48.948 36.3057 49.1604 36.1623 49.3073L26.7895 58.9775C26.678 59.0925 26.5258 59.1562 26.3682 59.1562H26.37ZM21.7854 44.9422L26.5895 57.5047L34.6471 49.1905L27.5914 47.1389C27.3648 47.0734 27.2002 46.877 27.1737 46.6433C27.1471 46.4079 27.2639 46.1813 27.471 46.0662L53.5873 31.5372L21.7872 44.944L21.7854 44.9422Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8571 54.9061C26.8359 54.9061 26.8147 54.9061 26.7934 54.9026C26.496 54.869 26.2819 54.5981 26.3155 54.3007L27.2129 46.5176C27.2466 46.2184 27.5156 46.006 27.8148 46.0396C28.1122 46.0733 28.3263 46.3441 28.2927 46.6415L27.3953 54.4247C27.3634 54.7026 27.128 54.9061 26.8554 54.9061H26.8571Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoney);
export default __webpack_public_path__ + "static/media/send_money.2e2d5b34398e08860bdbb867b5c82eb4.svg";
export { ForwardRef as ReactComponent };